<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.provider_requests_management") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Establishment Data Section -->
          <div class="col-12">
            <h3 class="section_title mb-4">
              <i class="fal fa-building mr-2"></i>
              {{ $t("PLACEHOLDERS.establishment_data") }}
            </h3>
          </div>

          <!-- Logo -->
          <div class="col-12 mb-3">
            <div class="text-center">
              <label class="detail_label d-block mb-3">{{ $t("PLACEHOLDERS.establishment_logo") }}</label>
              <div class="logo_container">
                <img 
                  v-if="data.logo" 
                  :src="data.logo" 
                  :alt="$t('PLACEHOLDERS.establishment_logo')"
                  class="establishment_logo"
                />
                <div v-else class="no_logo">
                  <i class="fal fa-image"></i>
                  <p>{{ $t("TABLES.noData") }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Establishment Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.establishment_name')"
            v-model="data.establishment_name"
            disabled
          />

          <!-- Commercial Registration Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_registration_number')"
            v-model="data.commercial_registration"
            disabled
          />

          <!-- Number of Branches -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.number_of_branches')"
            v-model="data.branches_count"
            disabled
          />

          <!-- Start:: Applicant Data Section -->
          <div class="col-12 mt-4">
            <h3 class="section_title mb-4">
              <i class="fal fa-user mr-2"></i>
              {{ $t("PLACEHOLDERS.applicant_data") }}
            </h3>
          </div>

          <!-- Full Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.applicant_name')"
            v-model="data.applicant_name"
            disabled
          />

          <!-- ID Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.identity_number')"
            v-model="data.identity_number"
            disabled
          />

          <!-- Mobile Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model="data.mobile"
            disabled
          />

          <!-- Email -->
          <base-input
            col="6"
            type="email"
            :placeholder="$t('PLACEHOLDERS.sender_email')"
            v-model="data.email"
            disabled
          />
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ShowProviderRequest",

  components: {},

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      EnRegex: /[\u0600-\u06FF]/,

      // Start:: Data Collection To Send
      data: {
        // Establishment Data
        logo: null,
        establishment_name: null,
        commercial_registration: null,
        branches_count: null,
        
        // Applicant Data
        applicant_name: null,
        identity_number: null,
        mobile: null,
        email: null,
      },

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),
  },

  methods: {
    // start show data
    async showData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `show-provider-requests-data/${this.$route.params.id}`,
        });

        const provider = res.data.data.provider;

        // Get logo from media array (provider-image collection)
        const providerImage = provider.media?.find(
          m => m.collection_name === 'provider-image'
        );

        // Establishment Data
        this.data.logo = providerImage?.original_url || provider.image;
        this.data.establishment_name = provider.provider_details?.brand_name || provider.name;
        this.data.commercial_registration = provider.provider_details?.commercial_register || '-';
        this.data.branches_count = provider.provider_details?.branches_count || 0;
        
        // Applicant Data
        this.data.applicant_name = provider.name;
        this.data.identity_number = provider.nationalId || '-';
        this.data.mobile = `${provider.country_code}${provider.mobile}`;
        this.data.email = provider.email;
      } catch (error) {
        this.loading = false;
        this.$message.error(error.response?.data?.message || this.$t("MESSAGES.error_fetching_data"));
      }
    },
    // end show data
  },

  created() {
    this.showData();
  },
};
</script>

<style lang="scss" scoped>
.details_wrapper {
  padding: 20px;
}

.section_container {
  background: #fff;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.section_title {
  color: #28877b;
  font-size: 1.4rem;
  font-weight: 600;
  border-bottom: 2px solid #28877b;
  padding-bottom: 12px;
  
  i {
    color: #28877b;
  }
}

.detail_item {
  margin-bottom: 20px;
}

.detail_label {
  font-weight: 600;
  color: #555;
  font-size: 0.95rem;
  margin-bottom: 8px;
  display: block;
}

.detail_value {
  color: #333;
  font-size: 1rem;
  padding: 12px 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  min-height: 45px;
}

.logo_container {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.establishment_logo {
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
  border-radius: 12px;
  border: 2px solid #e0e0e0;
  padding: 10px;
  background: #fff;
}

.no_logo {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  border: 2px dashed #ccc;
  border-radius: 12px;
  color: #999;
  
  i {
    font-size: 3rem;
    margin-bottom: 10px;
  }
  
  p {
    margin: 0;
    font-size: 0.9rem;
  }
}

@media (max-width: 767px) {
  .section_container {
    padding: 15px;
  }
  
  .section_title {
    font-size: 1.2rem;
  }
  
  .establishment_logo {
    max-width: 150px;
    max-height: 150px;
  }
  
  .no_logo {
    width: 150px;
    height: 150px;
  }
}
</style>
